const Dashboard = () => import(/* webpackChunkName: "application" */ '../application/components/Dashboard');
const Event = () => import(/* webpackChunkName: "application" */ './components/Event');
const FulfillApplication = () => import( './components/applications/fullfillApplication');
const LeaseCalculator = () => import(/* webpackChunkName: "application" */ './components/applications/createLease');
const LoanCalculator = () => import(/* webpackChunkName: "application" */ './components/applications/createLoan');
const Terms = () => import(/* webpackChunkName: "application-form" */ './components/applications/status/Terms');
const WaitingSubmission = () => import(/* webpackChunkName: "application-response" */ './components/applications/status/WaitingSubmission');

export default [
	{//Legacy urls
		path: 'application/dashboard/:applicationId',
		redirect: `dashboard/:applicationId`,
	},
	{
		path: 'application/4/:applicationId',
		redirect: `loan-application/submit/:applicationId`,
	},
	{
		name: 'Dashboard',
		path: '',
		component: Dashboard,
		meta: {requiresAuth: true}
	},
	/* Loan Creation Workflow */
	{
		component: LoanCalculator,
		meta: {requiresAuth: true},
		name: 'loanApplicants',
		path: 'loan-application/applicants/:applicationId?'
	},
	{
		component: LoanCalculator,
		meta: {requiresAuth: true},
		name: 'loanEquipment',
		path: 'loan-application/equipment/:applicationId?'
	},
	{
		component: LoanCalculator,
		meta: {requiresAuth: true},
		name: 'loanSave',
		path: 'loan-application/submit/:applicationId?'
	},
	{
		component: LoanCalculator,
		meta: {requiresAuth: true},
		name: 'loanCalculator',
		path: 'loan-application/:applicationId?'
	},
	/* Lease Creation Workflow */
	{
		component: LeaseCalculator,
		meta: {requiresAuth: true},
		name: 'leaseApplicants',
		path: 'lease-application/applicants/:applicationId?'
	},
	{
		component: LeaseCalculator,
		meta: {requiresAuth: true},
		name: 'leaseEquipment',
		path: 'lease-application/equipment/:applicationId?'
	},
	{
		component: LeaseCalculator,
		meta: {requiresAuth: true},
		name: 'leaseSave',
		path: 'lease-application/submit/:applicationId?'
	},
	{
		component: LeaseCalculator,
		meta: {requiresAuth: true},
		name: 'leaseCalculator',
		path: 'lease-application/:applicationId?'
	},
	/* Waiting Submit & Status Pages */
	{
		name: 'Terms',
		path: 'application/terms/:applicationId?',
		component: Terms,
		meta: {requiresAuth: true}
	},
	{
		name: 'WaitingSubmission',
		path: 'application/submitting/:applicationId?',
		component: WaitingSubmission,
		meta: {requiresAuth: true}
	},
	/* Fulfill application workflow */
	{
		name: 'Sign',
		path: 'sign/:applicationId',
		component: FulfillApplication,
		meta: {requiresAuth: true}
	},
	{
		name: 'BankVerification',
		path: 'bank-verification/:applicationId',
		component: FulfillApplication,
		meta: {requiresAuth: true}
	},
	{
		name: 'CompletionCertificate',
		path: 'completion-certificate/:applicationId',
		component: FulfillApplication,
		meta: {requiresAuth: true}
	},
	{
		name: 'UploadFiles',
		path: 'upload-files/:applicationId',
		component: FulfillApplication,
		meta: {requiresAuth: true}
	},
	{
		name: 'ApplicationDashboard',
		path: 'dashboard/:applicationId?',
		component: FulfillApplication,
		meta: {requiresAuth: true}
	},
	/* Application Event */
	{
		name: 'ApplicationEvent',
		path: 'application/:event/:applicationId',
		component: Event,
		meta: {requiresAuth: true}
	}
];
